import {ActionFlag} from './component';


export enum EventName {
    FormOnCreate = 'onCreate',
    FormAfterLoad = 'afterLoad',
    ComponentSelect = 'select',
    ComponentAdd = 'add',
    Button1 = 'button1',
    Button2 = 'button2',
    Button3 = 'button3'
}

export enum TriggerName {
    FormLoad = 'formLoad',
    CallFunction = 'call',
    ComponentValueSet = 'set',
    ComponentDisable = 'disableTrue',
    ComponentDisableClose = 'disableFalse',
}

export interface ITriggers {
    dataset_id: number;
    controlType: string;
    toName: string;
    toNameTitle: string;
    triggerName: TriggerName;
    whereValue: string;
    whereValueTitle: string;
    setValue: string;
    setValueTitle: string;
    functionId: any;
    functionName: string;
    index: number;
}

export interface IFormEvent {
    dataset_id: number;
    fromName: string;
    eventName: EventName;
    triggers: ITriggers[];
    buttonText?: string;
}

export interface IFormCustomeButton {
    buttonText: string;
    eventName: string;
}

export interface IDatasetFields {
    dataset_id?: number;
    default_value?: string;
    field_foreign_relation_dataset_id?: number;
    field_foreign_relation_setting?: any;
    field_foreign_type?: string;
    field_max_length?: number;
    field_is_foreign?: boolean;
    field_name?: string;
    field_type?: string;
    field_view_object_id?: any;
    id?: number;
    is_requared?: boolean;
    is_use?: boolean;
    is_use_label?: boolean;
    is_use_order?: boolean;
    is_use_filter?: boolean;
    is_photo_field?: boolean;
    is_dialog_show?: boolean;
    is_default_show?: boolean;
    field_hint_text?: string;
    field_ordinal_position?: number;
    field_title?: string;
}

export interface IFormItemsOption {
    form_type?: string;
    dataset_id?: number;
    dataset_fields?: IDatasetFields[];
}

export interface IFormItemsHeader {
    title: string;
    isSetTitle?: boolean;
    title_hint?: string;
    create_or_select?: string | undefined;
    checked: boolean
}

export interface IFormItemsControls {
    id?: string;
    name: string;
    text?: string;
    type?: string;
    label?: string;
    isList?: boolean;
    options?: any;
    disabled?: boolean;
    discardEditList?: boolean;
    requared?: boolean;
    design_ui?: string;
    hint_text?: string;
    maxLength?: number;
    prefixText?: string;
    suffixText?: string;
    defaultValue: any;
    defaultValueTitle?: any;
    placeHolderText?: string;
    suffixControlName?: string;
    suffixControlValue?: any | '';
    viewOptions?: IUIViewOptions;
}


export interface IUIViewOptions {
    cssClass?: string;

    width?: string;
    height?: string;

    selectedItems?: IOptionsItems[];
    formatString?: string;

    fieldRows?: IUIViewOptionFieldRow[];

    appSetting?: any;
    appPreQuery?: any;
    appShadowFields?: IShadowField[];

    survey_id?: number;
    survey_name?: string;

    appview_id?: number;
    appview_name?: string;
    set_status?: boolean;

    source_dataset_id?: number;
    source_dataset_name?: string;

}

export interface IShadowField {
    sourceFieldName: string;
    sourceFieldTitle: string;
    targetFieldName: string;
    targetFieldTitle: string;
}

export interface IShadowFieldPass {
    fieldName: string;
    fieldValue: any,
}

export interface IUIViewOptionFieldRow {
    list_order?: number;
    label?: string;
    field_name?: string;
    formatString?: string;
    fields?: IUIViewFieldRowItems[];
}

export interface IUIViewFieldRowItems {
    field_name: string;
    field_title: string;
    list_order: number;
}

export interface IOptionsItems {
    title: string;
    value: any;
}

export interface IFormItemsCol {
    order: number;
    fxCol: string;
    controls?: IFormItemsControls[];
}

export interface IFormItemsRow {
    row: number;
    header?: IFormItemsHeader;
    cols?: IFormItemsCol[];
}

export interface IFormItems {
    form_guid?: string;
    master_form_id?: any;
    total_row?: number;
    order?: number;
    rows?: IFormItemsRow[];
    option?: IFormItemsOption;
    header?: IFormItemsHeader;
    selectedRecordId?: number | undefined;
    isVisible?: boolean;

}


export interface IFormDefaults {
    dataset_id: number;
    field_name: string;
    id?: number;
    default_value?: any;
    field_foreign_relation_dataset_id?: number;
}

export interface IFormDataSetContainer {
    dataset_id: number;
    fields: IDatasetFields[];
}

export interface IForm {
    form_json: IFormItems[];
    defaults: IFormDefaults[];
    datasets: IFormDataSetContainer[];
    events?: IFormEvent[];
}

export interface IFormStructure {
    id: number;
    form_view_type_id: string;
    after_trigger_name?: string;
    after_trigger_type?: string;
    before_trigger_name?: string;
    before_trigger_type?: string;
    trigger_save: boolean;
    designer_type: string;
    form_json: IForm;
    form_name?: string;
    form_description?: string;
}

export interface IDatasetFileManagerCategoryItems {
    file_category_code: string;
    file_category_name?: string;
    require_is_new: boolean;
}

export interface IFormFileItem {
    file_link: string;
    file_name: string;
    file_extension: string;
    file_size: number;
    original_file_name: string;
    file_type_id: string;
    file_type_name?: string;
    id?: any;
}

export interface IFormFileUploadDialog {
    fileCategoryItems: IDatasetFileManagerCategoryItems[];
    fileCategoryItem?: IDatasetFileManagerCategoryItems;
    FORM_ID?: any;
    FORM_GUID: any;
    DATASET_ID?: any;
    formFileData?: IFormFileItem[];
}


export interface IFormSavingDataSetDataItem {
    name: string;
    value: any;
    title?: any;
    type?: any;
    special_id?: any;
}

export interface IFormSavingDataSets {
    dataset_id: number;
    data: IFormSavingDataSetDataItem[];
    create_or_select: string;
    select_record_id: number;
}

export interface IFormSavingForm {
    form_id: any;
    data: IFormSavingDataSetDataItem[];
    select_record_id?: number;
}

export interface IFormFilterOperation {
    field: string;
    op: string;
}

export interface IFormSavingData {
    dataset: IFormSavingDataSets[];
    form_data: IFormSavingForm[];
    filter_operation: IFormFilterOperation[];
    return_id?: any;
    out_data?: any;
}

export interface IFormSaveEmit {
    formSavingData: IFormSavingData;
    justRecordMe: boolean;
}

export interface IFormSaveStructure {
    data: IFormSavingData;
    out_data?: any;
    FORM_ID: number;
    RECORD_ID?: number | 0;
    FORM_GUID: any;
    flag: ActionFlag;
    masterDatasetId: number;
    rid: any;
}


export interface IActionPassData {
    target_dataset_id: number;
    target_field_name: string;
    target_field_foreign_relation_dataset_id: number;
    source_dataset_to_query_target_field_name: string;
    target_app: number;
    record_id: number;
    title: string;
    source_dataset_id: number;

    preQuery?: any[] | undefined;
    new_form_id?: number;
    new_form_text?: string;

    disableChildControl?: boolean;
    shadowFieldValues?: IShadowFieldPass[];
}

export interface IActionTriggerDataFields {
    name: string;
    value: any;
}

export interface IActionTriggerData {

    dataset_id: number;
    fields: IActionTriggerDataFields[];

}


export interface IStep2 {
    id: number;
    list_order: number;
    step_name: string;
    step_is_goback: boolean;
    step_is_last: boolean;
    after_lambda_function: string;
    before_lambda_function: string;
    show_step_record_number: boolean;
    hidden_step: boolean;
    next_action_button_title: string;
    multiple_turn_after: boolean;
    after_wf_id?: number;
    next_step_after_form_id?: number;
    prev_wf_id?: number;
    next_dataset_updateset_id?: number;
    prev_dataset_updateset_id?: number;
    back_action_button_title: string;
    appview_id: number;
}


export interface StepStructure {
    step_id: number;
    field_name: string;
    field_value: string;
    step_name: string;
    dataset_id: number;
}

export interface IActivityItem {
    icon: string;
    record_id: number;
    activity_type_id: string;
    dataset_id: number;
    title: string;
    timex: string;
    user_title: string;
    timex_hour: number;
}

export interface IActivity {
    items: IActivityItem[];
    date: string;
}
